import React from 'react';
import PropTypes from 'prop-types';
import InvoiceHeaderDetail from '../InvoiceHeaderDetail';
import LineJurisdiction from './c/lineJurisdiction/LineJurisdiction';
import SovosEditableSlidingPanel from 's1-ui/sovos-sliding-panel/SovosEditableSlidingPanel';
import AllocationGrid from 'shared/components/allocationGrid/AllocationGrid';
import {
  SLIDING_PANEL_DIALOG_ACTION_LABEL,
  SLIDING_PANEL_DIALOG_CONTENT_CLASS_NAME,
  SLIDING_PANEL_DIALOG_TEXT,
  SLIDING_PANEL_DIALOG_TITLE,
  SLIDING_PANEL_DIALOG_TITLE_CLASS_NAME
} from 'shared/constants/SharedConstants';
import { RULE_PROP_TYPE } from 'shared/constants/PropTypes';
import LinearProgress from '@material-ui/core/LinearProgress';
import LineAllocations from './c/lineAllocations/LineAllocations';
import InvoiceLineEditorSlidingPanel from './c/invoiceLineEditor/InvoiceLineEditorSlidingPanelConnector';
import './invoiceLineDetail.scss';

class InvoiceLineDetail extends React.PureComponent {
  state = {
    openSlidingPanel: false,
    selectedAllocation: { id: 0, name: '' },
    openInvoiceLineEditorSlidingPanel: false
  };

  openSlidingPanelOnClick = () => {
    this.props.rulesActions.fetchAllocationRules();
    this.setState({openSlidingPanel: true, selectedAllocation:  { id: 0, name: '' }});
  };

  handleCloseSlidingPanel = () => this.setState({ openSlidingPanel: false });

  onAllocationSelect = allocation => this.setState({ selectedAllocation: allocation });

  handleApplyButton = () => {
    const allocationInformation = { ruleId: this.state.selectedAllocation.id, lineIds: [this.props.invoiceLine.id] };
    this.props.rulesActions.applyAllocationRuleToLine(allocationInformation, this.props.invoiceLine.id);
    this.setState( { openSlidingPanel: false, selectedAllocation:  { id: 0, name: '' } });
  };

  handlePageChange = (page, perPage) => this.props.rulesActions.fetchAllocationRules(page, perPage);

  jurisdictionalResultsExist = () => {
    if ( this.props.invoiceDetail !== null ) {
      if ( this.props.invoiceDetail.jurisdictionItems === null &&
        this.props.invoiceDetail.allocationJurisdictions === null ) {
        return false;
      } else {
        return true;
      }   
    } 
    else {
      return false; 
    }
  }

  handleEditInvoiceLineClick = () => {
    this.setState({ openInvoiceLineEditorSlidingPanel: true });
  };

  handleCloseInvoiceLineEditorSlidingPanel = () => {
    this.props.onEditInvoiceLine();
    this.setState({ openInvoiceLineEditorSlidingPanel: false });
  };

  render() {
    const {
      invoiceLine,
      invoiceData,
      invoiceDateAndVendor,
      onCloseInvoiceLines,
      applyingAllocationRule,
      invoiceDetail,
      rules,
      fetchingRules,
      pageState,
      isLineAllocated,
      fetchingJurisdictionalBreakdown,
      fetchingInvoiceLineData
    } = this.props;
    const { openSlidingPanel, selectedAllocation, openInvoiceLineEditorSlidingPanel } = this.state;
    return (
      <React.Fragment>
        {
          fetchingJurisdictionalBreakdown &&
          <LinearProgress />
        }
        {
          !fetchingJurisdictionalBreakdown &&
          <React.Fragment>
            <InvoiceHeaderDetail
              invoice={ invoiceLine }
              invoiceDateAndVendor={ invoiceDateAndVendor }
              closeSlidingPanel={ onCloseInvoiceLines }
              onEditClick={ this.handleEditInvoiceLineClick }
              invoiceDetail={ invoiceDetail }
              fetchingInvoice={ fetchingInvoiceLineData }
            />
            {
              applyingAllocationRule &&
              <LinearProgress />
            }
            <div className={ `invoice-line-detail__container${applyingAllocationRule || fetchingInvoiceLineData ? ' blur-content' : '' } ` }>
              <div className="invoice-line-detail__title">
                <h1>Jurisdictional Breakdown</h1>
                <span 
                  style={ { cursor: 'pointer' } } 
                  onClick={ this.openSlidingPanelOnClick }
                >
                    APPLY ALLOCATION
                </span>
              </div>
              {
                !this.jurisdictionalResultsExist() &&
                <div className="invoice-line-detail__no-jurisdiction-label">
                  There are no jurisdictional results to display.
                </div>
              }
              {
                invoiceDetail && invoiceDetail.jurisdictionItems &&
                <LineJurisdiction invoiceDetail={ invoiceDetail } />
              }
              {
                isLineAllocated &&
                <React.Fragment>
                  {
                    invoiceDetail && invoiceDetail.allocationJurisdictions &&
                    <LineAllocations invoiceDetail={ invoiceDetail } />
                  }
                </React.Fragment>
              }
            </div>
            <SovosEditableSlidingPanel
              isDirty={ () => true }
              open={ openSlidingPanel }
              onClose={ this.handleCloseSlidingPanel }
              baseWidth={ '1230px' }
              title={ `Apply Allocation` }
              dialogTitle={ SLIDING_PANEL_DIALOG_TITLE }
              dialogText={ SLIDING_PANEL_DIALOG_TEXT }
              dialogContentClassName={ SLIDING_PANEL_DIALOG_CONTENT_CLASS_NAME }
              dialogActionLabel={ SLIDING_PANEL_DIALOG_ACTION_LABEL }
              SaveButtonProps={ {
                onClick: this.handleApplyButton,
                disabled: selectedAllocation.id === 0,
                children: 'APPLY'
              } }
              CancelButtonProps={ {
                children: 'CANCEL'
              } }
              CloseDialogProps={ {
                DialogTitleProps: {
                  children: SLIDING_PANEL_DIALOG_TITLE,
                  className: SLIDING_PANEL_DIALOG_TITLE_CLASS_NAME
                },
                DialogContentProps: {
                  children: SLIDING_PANEL_DIALOG_TEXT,
                  className: SLIDING_PANEL_DIALOG_CONTENT_CLASS_NAME
                },
                OKButtonProps: {
                  children: SLIDING_PANEL_DIALOG_ACTION_LABEL
                },
                CancelButtonProps: {
                  children: 'CANCEL'
                }
              } }
            >
              <AllocationGrid
                onAllocationSelect={ allocation => this.onAllocationSelect(allocation) }
                allocationRules={ rules }
                fetchingAllocations={ fetchingRules }
                pageState={ pageState }
                onPageChange={ (page, perPage) => this.handlePageChange(page, perPage) }/>
            </SovosEditableSlidingPanel >
          </React.Fragment>
        }
        <InvoiceLineEditorSlidingPanel
          open={ openInvoiceLineEditorSlidingPanel }
          onClose={ this.handleCloseInvoiceLineEditorSlidingPanel }
          invoiceNumber={ invoiceData.invoice }
          invoiceLineData={ invoiceLine }
        />
      </React.Fragment>
    );
  }
}

InvoiceLineDetail.propTypes = {
  invoiceLine: PropTypes.object.isRequired,
  invoiceData: PropTypes.object.isRequired,
  invoiceDateAndVendor: PropTypes.object,
  onCloseInvoiceLines : PropTypes.func.isRequired,
  fetchingInvoiceLineData: PropTypes.bool,
  fetchingJurisdictionalBreakdown: PropTypes.bool.isRequired,
  invoiceDetail: PropTypes.object,
  rulesActions: PropTypes.shape({
    fetchAllocationRules: PropTypes.func,
    applyAllocationRuleToLine: PropTypes.func
  }),
  invoicesActions: PropTypes.shape({
    fetchInvoiceById: PropTypes.func
  }),
  fetchingRules: PropTypes.bool,
  rules: PropTypes.arrayOf(RULE_PROP_TYPE).isRequired,
  pageState: PropTypes.object,
  isLineAllocated: PropTypes.bool.isRequired,
  applyingAllocationRule: PropTypes.bool,
  onEditInvoiceLine: PropTypes.func.isRequired
};

export default InvoiceLineDetail;



// WEBPACK FOOTER //
// ./src/components/viewTransactions/viewTransactionsGrid/c/invoiceLinesSlidingPanel/invoiceLinesDetail/InvoiceLinesDetail.js